import { types } from 'mobx-state-tree';

export const WorkPackageTabs = types
  .model({
    tab: types.number,
  })
  .actions(self => ({
    setTab: (val: number) => {
      self.tab = val;
    },
  }));

export default WorkPackageTabs;
